import { Utils } from 'mw-style-react';

export const GET_ACTORS_ACCOUNTS = Utils.createRequestTypes(
  'GET_ACTORS_ACCOUNTS'
);
export const CREATE_ACTORS_ACCOUNT = Utils.createRequestTypes(
  'CREATE_ACTORS_ACCOUNT'
);
export const BULK_CREATE_ACCOUNTS = Utils.createRequestTypes(
  'BULK_CREATE_ACCOUNTS'
);
export const REMOVE_ACTORS_ACCOUNT = Utils.createRequestTypes(
  'REMOVE_ACTORS_ACCOUNT'
);
export const LOCK_ACTORS_ACCOUNT = Utils.createRequestTypes(
  'LOCK_ACTORS_ACCOUNT'
);
export const UPDATE_ACTORS_ACCOUNT = Utils.createRequestTypes(
  'UPDATE_ACTORS_ACCOUNT'
);
export const GET_ACCOUNT_CURRENCIES = Utils.createRequestTypes(
  'GET_ACCOUNT_CURRENCIES'
);
export const CREATE_ACCOUNT_CURRENCIES = Utils.createRequestTypes(
  'CREATE_ACCOUNT_CURRENCIES'
);
export const UPDATE_ACCOUNT_CURRENCY = Utils.createRequestTypes(
  'UPDATE_ACCOUNT_CURRENCY'
);
export const REMOVE_ACCOUNT_CURRENCY = Utils.createRequestTypes(
  'REMOVE_ACCOUNT_CURRENCY'
);
export const GET_ACCOUNT_NAMES = Utils.createRequestTypes('GET_ACCOUNT_NAMES');
export const CREATE_ACCOUNT_NAME = Utils.createRequestTypes(
  'CREATE_ACCOUNT_NAME'
);
export const UPDATE_ACCOUNT_NAME = Utils.createRequestTypes(
  'UPDATE_ACCOUNT_NAME'
);
export const REMOVE_ACCOUNT_NAME = Utils.createRequestTypes(
  'REMOVE_ACCOUNT_NAME'
);
export const CREATE_TRANSACTION =
  Utils.createRequestTypes('CREATE_TRANSACTION');
export const REMOVE_TRANSACTION =
  Utils.createRequestTypes('REMOVE_TRANSACTION');
export const CREATE_GROUP_TRANSACTION = Utils.createRequestTypes(
  'CREATE_GROUP_TRANSACTION'
);
export const GET_TRANSACTIONS = Utils.createRequestTypes('GET_TRANSACTIONS');
export const GET_CHILD_TRANSACTIONS = Utils.createRequestTypes(
  'GET_CHILD_TRANSACTIONS'
);
export const SEARCH_TRANSACTIONS = Utils.createRequestTypes(
  'SEARCH_TRANSACTIONS'
);
export const GET_ACCOUNT_DETAILS = Utils.createRequestTypes(
  'GET_ACCOUNT_DETAILS'
);
export const GET_SINGLE_TRANSACTION = Utils.createRequestTypes(
  'GET_SINGLE_TRANSACTION'
);
export const GET_ACCOUNT = Utils.createRequestTypes('GET_ACCOUNT');
export const GET_CONNECTORS = Utils.createRequestTypes('GET_CONNECTORS');
export const ADD_CONNECTOR = Utils.createRequestTypes('ADD_CONNECTOR');
export const REMOVE_CONNECTOR = Utils.createRequestTypes('REMOVE_CONNECTOR');
export const SET_ACCOUNT_FORMULA = Utils.createRequestTypes(
  'SET_ACCOUNT_FORMULA'
);
export const GET_ACCOUNT_FORMULA_INFO = Utils.createRequestTypes(
  'GET_ACCOUNT_FORMULA_INFO'
);
export const SET_FORMULAS = Utils.createRequestTypes('SET_FORMULAS');

export const SET_ACTORS_ACCOUNTS_REQ_STATUS = 'SET_ACTORS_ACCOUNTS_REQ_STATUS';
export const CLEAR_ACTORS_ACCOUNTS = 'CLEAR_ACTORS_ACCOUNTS';
export const CLEAR_ACCOUNT_CURRENCIES = 'CLEAR_ACCOUNT_CURRENCIES';
export const CLEAR_ACCOUNT_NAMES = 'CLEAR_ACCOUNT_NAMES';
